"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerUrls = void 0;
exports.ServerUrls = {
    'cn-qa': 'https://qa-account-service.zhihuiya.com/',
    'cn-release': 'https://release-account-service.zhihuiya.com/',
    'cn-prod': 'https://account-service.zhihuiya.com/',
    'us-prod': 'https://account-service.passport.com/',
    'eu-prod': 'https://account-service.patsnap.eu/',
};
//# sourceMappingURL=variables.js.map